export default {"src":"/_next/static/media/add.7637bd5f.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};